// Package imports:
import React from "react";
// Component imports:
import ThinglystSkjolForm from './ThinglystSkjolForm';
import Link from '../../../ui-elements/Link/Link';
//Type imports:
import { MySettingsViewModel } from "../../../types/MyKeldaTypes";

interface IProps {
    model?: MySettingsViewModel
}
const ThinglystSkjol: React.FC<IProps> = ({
    model,
}) => {
    return (
        <div className="ThinglystSkjol">
            <div className="section__body">
                <h3>Þinglýst skjöl</h3>
                <p className="paragraph">Þegar óskað er eftir aðgangi að þinglýstum skjölum þarf að gefa skýringu á hvers vegna og staðfesta að aðgangur sé nauðsynlegur vegna starfsemi sinnar.</p>
                <p className="paragraph">Keldan áskilur sér þann rétt að sannreyna þær skýringar sem gefnar eru upp og veita öðrum upplýsingar um þær eftir því sem lög og reglur mæla fyrir um.</p>
                <Link
                    url="/Skilmalar"
                    linkSize="16"
                    icon='forward'
                >
                    Nánar um þinglýst skjöl í skilmálum Keldunnar
                </Link>
                <ThinglystSkjolForm model={model} />
            </div>
        </div>
    )
}

export default ThinglystSkjol;